// // src/routes/ProtectedRoute.tsx
// import { Navigate } from "react-router-dom";
// import { CometChat } from "@cometchat/chat-sdk-javascript";

// interface Props {
//   user: CometChat.User | null;
//   children: JSX.Element;
// }

// export default function ProtectedRoute({ user, children }: Props) {
//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }
//   return children;
// }
import React from "react";
import { Navigate } from "react-router-dom";
import { CometChat } from "@cometchat/chat-sdk-javascript";

interface Props {
  user: CometChat.User | null | undefined;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<Props> = ({ user, children }) => {
  /* ⏳ Still resolving login state */
  if (user === undefined) {
    return null; // or a loader
  }

  /* 🔒 Not logged in */
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  /* ✅ Logged in */
  return <>{children}</>;
};

export default ProtectedRoute;
